import * as React from 'react';
import * as classes from './vendor-info.scss';
import { OptionsViewModel } from '@models/common.models';
import { EditLink } from '@common/components/wizard/_components/wizard-edit-link.component';
import { DynamicSelectLookup } from '@common/components/dynamic-select-lookup/dynamic-select-lookup.component';
import { Link } from 'react-router-dom';
import { getRoute, RouteDefinitions } from '@common/route-definitions';

export interface VendorInfoCoverageNLimitsProperties {
  readonly jump?: (step: number) => void | undefined;
  readonly id: number;
  readonly liabilityExpiration?: Date;
  readonly liabilityWaiver?: boolean;
  readonly sdiExpiration?: Date;
  readonly sdiWaiver?: boolean;
  readonly hourlyRate: number;
  readonly overtimeRate: number;
  readonly weekendRate: number;
  readonly emergencyRate: number;
  readonly diagnosticRate: number;
  readonly secondWorkerRate: number;
  readonly authoLimit: number;

  readonly agreementType: OptionsViewModel;
  readonly agreementTypeOptions?: OptionsViewModel[];
  readonly agreementDate: Date;
  readonly dispatchLimitPermanent: number;
  readonly dispatchLimitTemp: number;
  readonly dispatchLimitExpiration: Date;
  readonly suspendedUntil: Date;

  readonly statReport?: boolean;
  readonly autoRerating?: boolean;
  readonly reportCard?: boolean;

  readonly vendorPortal?: boolean;
  readonly onlineAutho?: boolean;
  readonly noBidding?: boolean;

  readonly isTab?: boolean;
}

export class VendorInfoCoverageNLimitsComponent extends React.Component<VendorInfoCoverageNLimitsProperties> {
  render() {
    return (
      <section className={!this.props.isTab ? [classes.summary, 'row col-md-12'].join(' ') : classes.summary}>
        <div className={!this.props.isTab ? [classes.summaryCardRight, 'col-md-12'].join(' ') : classes.summary}>
          <div className="col-xs-12">
            <div className="row">
              <div className="col-xs-9">
                <h4>
                  {'Coverage & Limits'}{' '}
                  {this.props.isTab && (
                    <Link to={getRoute(RouteDefinitions.vendor.Edit, { id: +this.props.id })}>Edit</Link>
                  )}
                </h4>
              </div>
              <div className="col-xs-3 text-right">
                <h4>{!this.props.id ? <EditLink step={2} jump={this.props.jump} /> : ''}</h4>
              </div>
            </div>
            <div className="row">
              <div className="col-md-2">
                <label>Hourly Rate</label>
                <h5>{this.props.hourlyRate > 0 ? `$${this.props.hourlyRate}` : '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>Overtime Rate</label>
                <h5>{this.props.overtimeRate > 0 ? `$${this.props.overtimeRate}` : '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>Weekend Rate</label>
                <h5>{this.props.weekendRate > 0 ? `$${this.props.weekendRate}` : '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>Emergency Rate</label>
                <h5>{this.props.emergencyRate > 0 ? `$${this.props.emergencyRate}` : '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>Second Man Rate</label>
                <h5>{this.props.secondWorkerRate > 0 ? `$${this.props.secondWorkerRate}` : '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>Diagnostic Rate</label>
                <h5>{this.props.diagnosticRate > 0 ? `$${this.props.diagnosticRate}` : '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>Autho Limit</label>
                <h5>{this.props.authoLimit > 0 ? `$${this.props.authoLimit}` : '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>Agreement Type</label>
                <h5>
                  {this.props.agreementType ? (
                    <DynamicSelectLookup optVM={this.props.agreementType} opts={this.props.agreementTypeOptions} />
                  ) : (
                    '--'
                  )}
                </h5>
              </div>
              <div className="col-md-2">
                <label>Permanent Dispatch Limit</label>
                <h5>{this.props.dispatchLimitPermanent || '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>Temporary Dispatch Limit</label>
                <h5>{this.props.dispatchLimitTemp || '--'}</h5>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <label>Stat Report</label>
                <h5>
                  <i className={this.props.statReport ? 'fa fa-check' : 'fa fa-times'} />
                </h5>
              </div>
              <div className="col-md-4">
                <label>Auto Rerating</label>
                <h5>
                  <i className={this.props.autoRerating ? 'fa fa-check' : 'fa fa-times'} />
                </h5>
              </div>
              <div className="col-md-4">
                <label>Report Card</label>
                <h5>
                  <i className={this.props.reportCard ? 'fa fa-check' : 'fa fa-times'} />
                </h5>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <label>Vendor Portal</label>
                <h5>
                  <i className={this.props.vendorPortal ? 'fa fa-check' : 'fa fa-times'} />
                </h5>
              </div>
              <div className="col-md-4">
                <label>Online Autho</label>
                <h5>
                  <i className={this.props.onlineAutho ? 'fa fa-check' : 'fa fa-times'} />
                </h5>
              </div>
              <div className="col-md-4">
                <label>No Bidding</label>
                <h5>
                  <i className={this.props.noBidding ? 'fa fa-check' : 'fa fa-times'} />
                </h5>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-info/vendor-info-coverage-n-limits.component.tsx